/**
 * "1 task" / "3 tasks". Pass `plural` for irregular nouns ("entry" →
 * "entries") and `format` to render the number (e.g. toLocaleString).
 */
export function formatCount(
  count: number,
  singular: string,
  plural = `${singular}s`,
  format: (count: number) => string = String,
): string {
  return `${format(count)} ${count === 1 ? singular : plural}`
}
